import { useContext } from "react";
import { RelatedArticlesContext } from "../context/related-articles";

function useRelatedArticles(maxArticles = Infinity) {

  const relatedArticles = useContext(RelatedArticlesContext);

  if (relatedArticles.length > maxArticles) {
    return relatedArticles.slice(0, maxArticles);
  }
  return relatedArticles;
}

export default useRelatedArticles;
